import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import LzSApp from '@lz-app/App';
import Grid from '@mui/material/Grid';
import { LZ_DATE_FIELD_FORMAT, lzFGetFormattedDate, lzFGetMonthStartDate } from '@lz-services/Moment';
import useLzFApiCall from '@lz/services/Api';
import { lzFGetAppRouteFullUrl } from '@lz-services/Utils';
import LzXInputField from "@lz-components/forms/fields/InputField";
import LzXSwitchField from '@lz/components/forms/fields/SwitchField';

const SummaryOfSalesInvoicesReport = () => {
    const getInitParams = () => ({
        start_date: lzFGetMonthStartDate(LZ_DATE_FIELD_FORMAT),
        end_date: lzFGetFormattedDate('now', LZ_DATE_FIELD_FORMAT),
        fbr_pending_status: 0,
    });

    const [params, setParams] = useState(getInitParams());
    const apiCall = useLzFApiCall();

    const handleInputChange = (name, value, extras) => {
        const updated = Object.assign({}, params, extras || {});
        updated[name] = value;
        setParams(updated);
    };

    const handleReset = () => {
        setParams(getInitParams());
    };

    const handlePrint = () => {
        window.open(lzFGetAppRouteFullUrl('/reports/summary-of-sales-invoices-print/' + (0 === params.fbr_pending_status ? 'show-all' : (1 === params.fbr_pending_status ? 'only-pending' : 'only-sent')) + '/' + params.start_date + '/' + params.end_date + '/'), '_blank');
    };

    const handleExport = async () => {
        await apiCall('reports/summary-of-sales-invoices/export-csv', params);
    };

    return (
        <LzSApp.WrapperTemplate private screenTitle="Summary of Sales Invoices">

            <Paper elevation={2} style={{ paddingTop: 24, paddingBottom: 16 }}>
                <Container>

                    <Grid container spacing={2}>
                        <Grid item sm={4} md={2}>
                            <LzXInputField fluid required variant="outlined" type="date" label="Start Date" name="start_date"
                                value={params.start_date} onChange={handleInputChange} />
                        </Grid>
                        <Grid item sm={4} md={2}>
                            <LzXInputField fluid required variant="outlined" type="date" label="End Date" name="end_date"
                                value={params.end_date} onChange={handleInputChange} />
                        </Grid>
                        <Grid item sx={{ flexGrow: 1 }}>
                            <div style={{ fontSize: 12, color: 'gray' }}>FBR Pending Status:</div>
                            <LzXSwitchField label="Show All" name="fbr_pending_status" value={0 === params.fbr_pending_status}
                                onChange={(nm, val) => handleInputChange(nm, 0)} />
                            <LzXSwitchField label="Only Pending" name="fbr_pending_status" value={1 === params.fbr_pending_status}
                                onChange={(nm, val) => handleInputChange(nm, 1)} />
                            <LzXSwitchField label="Only Sent" name="fbr_pending_status" value={2 === params.fbr_pending_status}
                                onChange={(nm, val) => handleInputChange(nm, 2)} />
                        </Grid>
                    </Grid>

                    <div style={{ textAlign: 'right', paddingTop: 16, paddingBottom: 16 }}>
                        <Button type="button" color="primary" variant="contained" onClick={handlePrint}>Preview</Button>
                        <Button type="button" style={{ marginLeft: 10 }} onClick={handleExport}>Export Csv</Button>
                        <Button type="button" style={{ marginLeft: 10 }} onClick={handleReset}>Reset</Button>
                    </div>

                    <Alert>Please select the above parameters and preview the report...</Alert>

                </Container>
            </Paper>

        </LzSApp.WrapperTemplate>
    );

};

export default SummaryOfSalesInvoicesReport;
